import { LOCAL_FONT_PROTOCOL } from "../../common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

export const HelveticaFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: LOCAL_FONT_PROTOCOL,
  },
];
